import { Employee } from "../services/employee.ts";

const ADMIN_EMAILS = new Set([
    "gzake@kiiramotors.com",
    "mburutira@kiiramotors.com",
    "jrsejjungo@kiiramotors.com",
    "bkushaba@kiiramotors.com",
    "stipa@kiiramotors.com",
    "hnangonzi@kiiramotors.com",
    "bkyabangi@kiiramotors.com",
    "rmadanda@kiiramotors.com",
    "rnasejje@kiiramotors.com",
    "ajasiimwe@kiiramotors.com",
    "aziryawulawo@kiiramotors.com",
]);

export const shouldUseAdminLanding = (employee: Employee | undefined): boolean => {
    if (!employee) {
        return false;
    }

    return employee.division === 1 || ADMIN_EMAILS.has(employee.email) || employee.unit === 15;
};

export const getAuthenticatedHomeRoute = (employee: Employee | undefined): string => {
    return shouldUseAdminLanding(employee) ? "/distribute" : "/client/vehicle-models";
};
